export default {"src":"/_next/static/media/arrow-bottom-white.bcdb78c7.svg","height":18,"width":13,"blurWidth":0,"blurHeight":0};